/* *** START VANILLA JS *** */

/* NAV */
var mobileNavToggle = (function() {

	// Variables
	let toggleButton = null;
	let bodyTag = null;
	let navBanner = null;
	let nav = null;

	// Private functions


	// Public functions
	var publicNavAPI = {};

	publicNavAPI.resetNav = function() {
		let navLevel1 = document.querySelector('header div.collapse');
		if (toggleButton !== null && toggleButton.classList.contains("show")) {
			toggleButton.setAttribute('aria-expanded', 'false');
			toggleButton.classList.remove('show');
			bodyTag.classList.remove('nav-open');
			nav.removeAttribute('style');
			navLevel1.classList.remove('show');
			let submenu = document.querySelector('li.dropdown >ul.dropdown-menu.show');
			if (submenu !== null) {
				submenu.classList.remove("show");
			}
		} else {
			toggleButton.setAttribute('aria-expanded', 'true');
			toggleButton.classList.add('show');
			bodyTag.classList.add('nav-open');

			// Change offset
			publicNavAPI.handleNavOffset();
			navLevel1.classList.add('show');
		}
	};

	publicNavAPI.handleNavOffset = function() {

		// Check to see if alerts are present in header, if so add to banner offset
		let headerLvlAlerts = document.querySelectorAll('header > .alert');
		let alertOffset = 0;
		headerLvlAlerts.forEach(alert => {
			alertOffset += alert.clientHeight;
		});

		nav.style.top = alertOffset + navBanner.clientHeight + 'px';
	};

	publicNavAPI.handleWindowBlur = function() {
		if (toggleButton !== null && toggleButton.classList.contains("show")) {
			publicNavAPI.resetNav();
		}
	};

	publicNavAPI.handleNavLinkClick = function(e) {
		let mchild = e.target.nextElementSibling;

		if (!mchild) {
			return;
		}

		if (mchild.classList.contains("show")) {
			mchild.classList.remove("show");
		} else {
			mchild.classList.add("show");
		}
	};

	publicNavAPI.handleNavLinkFocus = function() {
		document.querySelectorAll('ul.dropdown-menu').forEach(dd => {
			dd.classList.remove('show');
		});

		document.querySelectorAll('li.keypress-show').forEach(li => {
			li.classList.remove('keypress-show');
		});
	};

	publicNavAPI.handleNavLinkDownArrow = function(e) {
		let openeventKeys = [ 'Enter', 'ArrowDown', 'Down', ' ', 'Spacebar' ];

		if (openeventKeys.indexOf(e.key) >= 0) {
			e.preventDefault();
			let ulItem = e.target.nextElementSibling;// Show the dropdown menu
			if (ulItem.classList.contains('dropdown-menu')) {
				if (ulItem.classList.contains('show')) {
					ulItem.classList.remove('show');
				} else {
					ulItem.classList.add('show');
				}
			}

			let ilItem = e.target.closest('li');// Apply the hover styling to the li
			if (ilItem.classList.contains('nav-menuItem')) {
				if (ilItem.classList.contains('keypress-show')) {
					ilItem.classList.remove('keypress-show');
				} else {
					ilItem.classList.add('keypress-show');
				}
			}

			// Firefox double dips on the keydown functionality from the botton controller JS
			let ffCheck = -1;
			if (navigator.userAgent.indexOf("Firefox") !== ffCheck && e.key === ' ' ) {
				if (ulItem.classList.contains('dropdown-menu')) {
					if (ulItem.classList.contains('show')) {
						ulItem.classList.remove('show');
					} else {
						ulItem.classList.add('show');
					}
				}
			}
		}
	};

	publicNavAPI.handleBackLinkClick = function(e) {
		let mparent = e.target.parentElement.parentElement;
		mparent.classList.remove('show');
	};

	publicNavAPI.handleDOMContentLoaded = function() {
		// Variables
		toggleButton = document.querySelector('button.navbar-toggler');
		bodyTag = document.body;
		navBanner = document.querySelector('body >header >.container');
		nav = document.querySelector('body >header >nav.navbar .navbar-collapse');
		// Turn on event listener
		window.addEventListener('blur', publicNavAPI.handleWindowBlur);
		// If there's a toggle button add resetNav click event listener
		if (toggleButton !== null) {
			toggleButton.addEventListener('click', publicNavAPI.resetNav);
		}
		// Loop through nav-links and add click and focus event listeners
		document.querySelectorAll('li.dropdown > .nav-link').forEach(menu => {
			menu.addEventListener('click', publicNavAPI.handleNavLinkClick);
			menu.addEventListener('focus', publicNavAPI.handleNavLinkFocus);
		});
		// Loop through nav-links and add down arrow event listeners
		document.querySelectorAll('li.nav-menuItem > button.nav-link').forEach(downarrow => {
			downarrow.addEventListener('keydown', publicNavAPI.handleNavLinkDownArrow);
		});
		// Loop through backlinks and add click event listeners
		document.querySelectorAll('li.dropdown > ul.dropdown-menu > li > a.backLink').forEach(backlink => {
			backlink.addEventListener('click', publicNavAPI.handleBackLinkClick);
		});
		// Add tab press event to last link
		let pNavLinks = document.querySelectorAll('ul.dropdown-menu > li.row > ul.col-xl > li > a.dropdown-item');
		let lastLink = pNavLinks[pNavLinks.length - 1];
		if (lastLink !== undefined) {
			lastLink.addEventListener('keydown', function(event) {
				if (event.key === 'Tab') {
					lastLink.closest('ul.dropdown-menu.show').classList.remove('show');
				}
			});
		}
		// When alert dismissible button is pressed, reset the offset of the nav
		document.querySelectorAll('header > .alert').forEach(alert => {
			alert.addEventListener('click', publicNavAPI.handleNavOffset);
			alert.addEventListener('keydown', function(e) {
				let spaceKeyCode = 'Space';
				let closeeventKeys = [ 'Spacebar', 'Enter' ];

				if (closeeventKeys.indexOf(e.key) >= 0 || e.code === spaceKeyCode) {
					publicNavAPI.handleNavOffset();
				}
			});
		});
	};

	return publicNavAPI;
}());
window.addEventListener('load', mobileNavToggle.handleDOMContentLoaded); //end ready

if (typeof exports !== 'undefined') {
	module.exports = mobileNavToggle;
}
/* eslint-enable no-unused-vars */